import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Flag } from '@hivebrite/design-system/Flag';

const ThumbnailContent = ({ tag, children }) => (
  <Box
    position="relative"
    display="block"
    data-testid="thumbnail-content-wrapper"
  >
    {children}
    <StyledTag>
      <Flag
        text={tag === 'external link' ? s__('Portfolio|external link') : tag}
      />
    </StyledTag>
  </Box>
);

ThumbnailContent.propTypes = {
  tag: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ThumbnailContent;

const StyledTag = styled(Box).attrs({
  position: 'absolute',
})`
  top: 10px;
  left: 8px;
  z-index: 1;
`;
